// extracted by mini-css-extract-plugin
export default {"block_item":"index_block_item_Rp6ir","ht":"index_ht_AY995","ht_t":"index_ht_t_AWOV6"};